<template>
  <div id="contenedor-contrato-fianzas-tool-bar">
    <v-toolbar flat color="transparent">
      <v-spacer></v-spacer>
      <custom-button
        v-if="mixValidaScopesActions(1)"
        label="Nueva"
        iconText="mdi-plus"
        tipo="agregar"
        @click="nueva">
      </custom-button>
    </v-toolbar>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'ContratoFianzasToolBar',
  components: {
    CustomButton,
  },
  data() {
    return {};
  },
  methods: {
    nueva() {
      this.$emit('nuevaEscalatoria');
    },
  },
};
</script>

<style lang="scss">

</style>
